import React from "react";
import { editbtn } from "../atoms/lattice";
import { useRecoilValue, useRecoilRefresher_UNSTABLE } from "recoil";
import ReactQuill from "react-quill";
import { insertLearningInfo } from "../api/update";
import { rolSkillLearn } from "../selectors/lattice";
import "react-quill/dist/quill.snow.css";
export function Prolearn(values) {
  
  return  (
    <>
      <div className="py-2">
        <h3 className="with-grey-bg">Learning Courses</h3>
        <span dangerouslySetInnerHTML={{ __html: values?.details }} />
      </div>
    </>
  ) ;
}
